<h2>{{ 'cart.savedCartList.savedCartHeader' | cxTranslate }}</h2>
@if (isLoadingSavedCartsData) {
<div class="loading-container">
  <mat-spinner [diameter]="72"></mat-spinner>
</div>
} @else { @if (savedCartsCount >= 0) {
<p [innerHtml]="'cart.savedCartList.savedCartsInfo' | cxTranslate : { count: savedCartsCount }"></p>
} @if (savedCartsCount > 0) {
<div class="d-flex flex-sm-column flex-md-row justify-content-md-between">
  <app-sorting
    [sortOptions]="sortOptions"
    [sortLabels]="sortLabels | async"
    (sortListEvent)="sortChange($event)"
    [selectedOption]="sort"
  >
  </app-sorting>
  <div class="import-csv-container">
    <button class="btn btn-link p-0 border-0" mat-icon-button disableRipple (click)="goToBulkImport()">
      <mat-icon svgIcon="import" class="import align-middle"></mat-icon
      ><span class="align-middle">{{ 'csvImport.label' | cxTranslate }}</span>
    </button>
  </div>
</div>
} @if (savedCartsCount > 0 && showSrp && isDesktop) {
<app-table [columns]="columnsSrpOn" [dataSource]="dataSource" [pageSize]="payload.pageSize" [paginator]="null">
</app-table>
} @if (savedCartsCount > 0 && !showSrp && isDesktop) {
<app-table [columns]="columnsSrpOff" [dataSource]="dataSource" [pageSize]="payload.pageSize" [paginator]="null">
</app-table>
}
<div class="saved-carts-list-container mobile">
  @if (!isDesktop && savedCartsData) {
  <div class="card-columns">
    @for (cart of savedCartsData; track cart) {
    <div class="card border-0">
      <div class="card-body">
        <h5 class="card-title mb-0">{{ columnsSrpOn[0].displayName }}</h5>
        <a
          tabindex="0"
          class="card-text text-force-truncate"
          [routerLink]="{ cxRoute: 'savedcartDetails', params: cart } | cxUrl"
        >
          <app-tooltip-text [tooltipContent]="cart.name" [content]="cart.name" placement="bottom"></app-tooltip-text>
        </a>
        <div class="row no-gutters">
          <div class="col-6 cart-code">
            <h5 class="card-title mb-0">{{ columnsSrpOn[1].displayName }}</h5>
            <p class="card-text">{{ cart.code }}</p>
          </div>
          <div class="col-6">
            <h5 class="card-title mb-0">{{ columnsSrpOn[2].displayName }}</h5>
            <p class="card-text">{{ cart.saveTime | date : 'dd-MM-yyyy' }}</p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-6 created-by">
            <h5 class="card-title mb-0">{{ columnsSrpOn[3].displayName }}</h5>
            <p class="card-text">{{ cart.createdBy }}</p>
          </div>
          @if (!showSrp) {
          <div class="col-6">
            <h5 class="card-title mb-0">{{ columnsSrpOff[4].displayName }}</h5>
            <p class="card-text">{{ cart.dealerPrice }}</p>
          </div>
          }
        </div>
        <div class="row no-gutters">
          <div class="col-6">
            <h5 class="card-title mb-0">{{ columnsSrpOn[4].displayName }}</h5>
            <p class="card-text">{{ cart.importStatus == 'PROCESSING' ? '-' : cart.totalItems }}</p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12">
            <h5 class="card-title mb-0">{{ columnsSrpOn[5].displayName }}</h5>
            <div class="card-text">
              @if (cart.importStatus == 'PROCESSING') {
              <div>
                {{ 'csvImport.saveCart.importProcessing' | cxTranslate }}
              </div>
              } @if (cart.importResult && !cart.description) {
              <div>
                {{
                  'csvImport.saveCart.importDesc'
                    | cxTranslate
                      : { importRef: cart.importResult.importRef, importSuccess: cart.importResult.importSuccess }
                }}
                @if (cart.importResult.importFailed) {
                {{ 'csvImport.saveCart.importDescFailed' | cxTranslate }}
                <button class="tertiary-btn btn" style="height: auto" (click)="openError(cart.code)">
                  {{
                    'csvImport.saveCart.importDescFailedNumber'
                      | cxTranslate : { importFailed: cart.importResult.importFailed }
                  }}
                </button>
                }
              </div>
              } @else {
              <div [innerHTML]="cart.description"></div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer p-0">
        <div class="row no-gutters">
          <div class="col-6 h-100 border-right">
            <button
              class="w-100 border-0 rounded-0 my-auto"
              mat-icon-button
              (click)="onDeleteSavedCartModal(cart.code, cart.name)"
            >
              <mat-icon class="material-icons light delete-cart">delete_outline</mat-icon>
            </button>
          </div>
          <div class="col-6 h-100">
            <button
              class="w-100 border-0 rounded-0 my-auto"
              mat-icon-button
              (click)="onRestoreSavedCartModal(cart.name, cart.code, cart.totalItems)"
            >
              <mat-icon matBadge="+" matBadgeSize="large" class="material-icons-sharp light restore-cart"
                >shopping_cart</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
@if (savedCartsCount > 0) {
<div class="pagination-container">
  <app-pagination
    (viewPageEvent)="pageChange($event)"
    [pagination]="PaginationModel"
    [hideOnSinglePage]="true"
  ></app-pagination>
</div>
} }
